import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { OrderDto } from 'src/app/models/order-dto';
import { OrderService } from 'src/app/services/order.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OperationsKanbanBoardComponent } from '../operations-kanban-board/operations-kanban-board.component';

@Component({
    selector: 'oaibox-operations-page',
    templateUrl: './operations-page.component.html',
    styleUrl: './operations-page.component.css',
    imports: [
        ReactiveFormsModule,
        FormsModule,
        OperationsKanbanBoardComponent,
    ],
})
export class OperationsPageComponent implements OnDestroy {

  private orders: OrderDto[] = [];
  protected shownOrders: OrderDto[] = [];

  protected keyword: string = '';

  private ordersSubscription?: Subscription;

  constructor(orderService: OrderService) {
    this.ordersSubscription = orderService.getOrders$().subscribe(orders => {
      this.orders = orders;
      this.shownOrders = orders;
    });
    orderService.refreshOrders();
  }

  protected filterMatchingOrders(): void {
    const keyword = this.keyword.trim().toLowerCase();

    if (!keyword) {
      this.shownOrders = [...this.orders];
      return;
    }

    this.shownOrders = this.orders.filter(order => {
      const title = (order.title ?? '').toLowerCase();
      const customerName = (order.customerName ?? '').toLowerCase();
      const customerEmailAddress = (order.customerEmailAddress ?? '').toLowerCase();

      return (
        title.includes(keyword) ||
        customerName.includes(keyword) ||
        customerEmailAddress.includes(keyword)
      );
    });
  }

  ngOnDestroy(): void {
    this.ordersSubscription?.unsubscribe();
  }

}
